module.exports = __webpack_public_path__ + "5f6ed5d9c021e22dce4735149b8b28fa.pdf";